/**
 * Retrieves the translation of text.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/packages/packages-i18n/
 */
import { __ } from '@wordpress/i18n';
import { useState } from '@wordpress/element';
import { useDispatch,dispatch } from '@wordpress/data';

/**
 * Lets webpack process CSS, SASS or SCSS files referenced in JavaScript files.
 * Those files can contain any CSS code that gets applied to the editor.
 *
 * @see https://www.npmjs.com/package/@wordpress/scripts#using-css
 */
import './style.scss';

// Get the payment method data from WooCommerce Blocks
const settings = window.wc.wcSettings.getPaymentMethodData('youseeme_card', {
    title: __('Card Payment', 'youseeme'),
    description: '',
    plugin_url: '',
    supports: []
});

const { PAYMENT_STORE_KEY } = window.wc.wcBlocksData;

/**
 * The View component handles the card payment interface in the frontend.
 *
 * @return {Element} The payment form element.
 */
export default function View() {
	
    const [isProcessing, setIsProcessing] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const { createErrorNotice } = useDispatch('core/notices');

    // Get the payment gateway data
    const { title, description, plugin_url: pluginUrl, nonce,ajax_url } = settings;

    const handlePayment = async (e) => {
        e.preventDefault();
        setIsProcessing(true);
        setErrorMessage('');

        try {
            // Get the current order data
            const formData = new FormData();
            formData.append('action', 'youseeme_create_card_payment');
            formData.append('youseeme_card-payment-nonce', nonce);


            // Add the payment method to the form data
            formData.append('payment_method', 'youseeme_card');

            // Make the AJAX call to create the payment
            const response = await fetch(ajax_url, {
                method: 'POST',
                credentials: 'same-origin',
                body: formData
            });


            const result = await response.json();
            
            if (!result.success || !result.data.paymentUrl) {
                throw new Error(result.messages || 'Payment processing failed');
            }

            // If we have a redirect URL, open it in a new window
            const { paymentUrl, paymentTotal } = result.data;
        
            
			dispatch( PAYMENT_STORE_KEY ).__internalSetPaymentMethodData( {
				youseeme_data: JSON.stringify( {
					youseeme_card_payment_total: paymentTotal,
					youseeme_card_payment_url: paymentUrl,
				} ),
			} );
            
            
            // Open payment URL in a new window
            const paymentWindow = window.open('', 'youseeme_payment', 'width=600,height=600');
            if (paymentWindow) {
                paymentWindow.location.href = paymentUrl;
            } else {
                // If popup is blocked, redirect in the same window
                window.location.href = paymentUrl;
            }

        } catch (error) {
            console.error('Payment error:', error);
            setErrorMessage(error.message || 'An error occurred while processing your payment');
            createErrorNotice(error.message || 'An error occurred while processing your payment', {
                type: 'error',
                isDismissible: true,
            });
        } finally {
            setIsProcessing(false);
        }
	
    };

    return (
        <div className="payment_box payment_method_youseeme_card">
            <p>{description || __('Pay securely using your credit or debit card', 'youseeme')}</p>
			<div className="youseeme-card-payment">
                <button 
                    id="youseeme-pay-now-button" 
                    className="button alt wp-element-button wc-block-components-button button alt"
                    onClick={handlePayment}
                    disabled={isProcessing}
                >
                    {isProcessing ? __('Processing...', 'youseeme') : __('Pay now', 'youseeme')}
                </button>
                
                {isProcessing && (
                    <div className="youseeme-payment-message">
                        <p>{__('Processing your payment...', 'youseeme')}</p>
                    </div>
                )}
                
                {errorMessage && (
                    <div className="woocommerce-error" role="alert">
                        {errorMessage}
                    </div>
                )}
                
                <div id="youseeme-payment-progress" style={{display: 'none', marginTop: '15px'}}>
                    <p>{__('Once your payment is done, please validate your order below', 'youseeme')}</p>
                </div>
            </div>
		
			<div className="youseeme-payment-description-extra">
				<img 
                        src={`${pluginUrl || ''}/assets/lock.png`} 
                        alt="Visa" 
						width={30}
                        className="youseeme-card-logo" 
                    />
				Safe and secure checkout 
                    <img 
                        src={`${pluginUrl || ''}/assets/visa.svg`} 
                        alt="Visa" 
						width={30}
                        className="youseeme-card-logo" 
                    />
                    <img 
                        src={`${pluginUrl || ''}/assets/mastercard.svg`} 
                        alt="Mastercard" 
						width={30}
                        className="youseeme-card-logo" 
                    />
                
            </div>
        </div>
	
    );
}
